import * as React from 'react';
import { Text } from '@box/blueprint-web';
import css from '../../group.module.scss';
import { getTitleContainerId } from '../../../../utils/group';

type Props = {
  components: React.ReactNode;
  description?: React.ReactNode;
  id: string;
  label?: React.ReactNode;
};

const BlueprintSubmitterGroup = React.memo<Props>((props: Props) => {
  const { id, label, description, components } = props;

  return (
    <>
      <div
        className={css.groupTitleContainerBlueprint}
        id={getTitleContainerId(id)}
      >
        {label ? (
          // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2322
          <Text as="div" variant="titleMondo">
            {label}
          </Text>
        ) : null}
        {description ? (
          <Text
            // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2322
            as="div"
            className={css.groupDescriptionBlueprint}
            variant="bodyLarge"
          >
            {description}
          </Text>
        ) : null}
      </div>
      {components}
    </>
  );
});

export { BlueprintSubmitterGroup };
export default BlueprintSubmitterGroup;
